import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import areaCalculation from '../../../../algorithms/geometry/AreaCalculation';

export const EditFieldBoundariesStatus = ({ LangFile, selectedField, hectaresToAdd }) => {
  const selectedFieldSize = areaCalculation({
    coords: selectedField.polygon.coordinates[0].map((coord: [number, number]) => ({
      lng: coord[0],
      lat: coord[1],
    })),
  }).size.toFixed(2);

  return (
    <Box>
      <Divider
        style={{
          marginTop: 0,
          marginBottom: '8px',
          backgroundColor: '#ddd',
        }}
      />

      <Box
        style={{ marginBottom: '8px' }}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="body2">{LangFile.PolygonDrawing.currentFieldArea + ':'}</Typography>
        <Typography variant="body2" style={{ fontWeight: 'bold', color: '#2c3e50' }}>
          {selectedFieldSize} ha
        </Typography>
      </Box>

      <Box
        style={{
          fontSize: '14px',
          color: '#333',
          fontWeight: 500,
        }}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="body2">{LangFile.PolygonDrawing.newFieldArea + ':'}</Typography>
        <Typography variant="body2" style={{ fontWeight: 'bold', color: '#2c3e50' }}>
          {hectaresToAdd} ha
        </Typography>
      </Box>
    </Box>
  );
};
